const baseURL = "https://erp.cranoistmhe.com/"
// const baseURL = "http://127.0.0.1:8000/"
// const baseURL = "http://192.168.31.16:8000/"
const config = {
    
    apiBaseURL : `${baseURL}`,
    staticBaseURL : `${baseURL}`,
    apiTimeout: 500000
}
export default config;

